export default __webpack_public_path__ + "static/logo-4-6248fdb40f42e8a9e2e4e6a7e2b92d97.webp";